import * as React from 'react';
const CheckboxChecked = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <mask id="mask0_934_1092" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_934_1092)">
      <path
        d="M10.6 13.7462L8.27688 11.4231C8.13842 11.2846 7.96439 11.2138 7.75478 11.2106C7.54518 11.2074 7.36794 11.2782 7.22308 11.4231C7.07819 11.568 7.00575 11.7436 7.00575 11.95C7.00575 12.1564 7.07819 12.332 7.22308 12.4769L9.9673 15.2211C10.1481 15.4019 10.359 15.4923 10.6 15.4923C10.841 15.4923 11.0519 15.4019 11.2327 15.2211L16.7961 9.65768C16.9346 9.51923 17.0054 9.3452 17.0086 9.13558C17.0118 8.92596 16.941 8.74872 16.7961 8.60386C16.6513 8.45899 16.4756 8.38656 16.2692 8.38656C16.0628 8.38656 15.8872 8.45899 15.7423 8.60386L10.6 13.7462ZM5.3077 20.5C4.80257 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30773C3.5 4.8026 3.675 4.37503 4.025 4.02503C4.375 3.67503 4.80257 3.50003 5.3077 3.50003H18.6923C19.1974 3.50003 19.625 3.67503 19.975 4.02503C20.325 4.37503 20.5 4.8026 20.5 5.30773V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.3077Z"
        fill="#1A73E9"
      />
    </g>
  </svg>
);
export default CheckboxChecked;
